<template>
  
  <div class="haier-help">
    <h-date-picker :title="'不良闭环时间段'" :theme="'hwork'"
      type="daterange"
      v-model="postData.happenEndTime"
      range-separator="-"
      start-placeholder="开始" end-placeholder="结束"
      :change="happenEndTimeChange(postData.happenEndTime)"
      clearable>

      <template v-slot:left>
        <span>*</span>
      </template>
      <template v-slot:right>
        <span>?</span>
      </template>

    </h-date-picker>
    <h-date-picker :title="'测试生成这个页'" :theme="'hwork'"
      type="daterange"
      v-model="postData.pageTime"
      range-separator="-"
      placeholder="时间"
      :change="pageTimeChange(postData.pageTime)"
      clearable>
    </h-date-picker>
    
    <h-date-picker :title="'突然去'" :theme="'hwork'"
      type="daterange"
      v-model="postData.pageTime2"
      range-separator="-"
      placeholder="时间"
      :change="pageTime2Change(postData.pageTime)"
      clearable>
      <template v-slot:right>
        <span>?</span>
      </template>
    </h-date-picker>

    <h-date-picker :title="'他吞吞吐吐天天'" :theme="'hwork'"
      type="daterange"
      v-model="postData.pageTime3"
      range-separator="-"
      placeholder="时间"
      :change="pageTime3Change(postData.pageTime)"
      clearable>
      <template v-slot:left>
        <span>*</span>
      </template>
    </h-date-picker>

    <h-date-picker :title="'年年年年年年年年'" :theme="'hwork'"
      type="year"
      v-model="postData.pageTime4"
      range-separator="-"
      placeholder="时间"
      :change="pageTime4Change(postData.pageTime)"
      clearable>
      <template v-slot:left>
        <span>*</span>
      </template>
    </h-date-picker>
    <h-date-picker :title="'的如歌'" :theme="'hwork'"
      type="mounth"
      v-model="postData.pageTime5"
      range-separator="-"
      placeholder="time"
      :change="pageTime4Change(postData.pageTime)"
      clearable>
      <template v-slot:left>
        <span>*</span>
      </template>
    </h-date-picker>

    <br>
    <h-haier>wrwerwer</h-haier>
    <h1>样式预览</h1>
    <h2>按钮样式 h-button (默认)</h2>
    <div style="display: flex;width: 500px;justify-content: space-between">
      <h-button type="default">type=default</h-button>
      <h-button type="warning">type=warning</h-button>
      <h-button type="primary">type=primary</h-button>
      <h-button type="text">type=text</h-button>
    </div>
    <h2>按钮样式-禁用</h2>
    <div style="display: flex;width: 500px;justify-content: space-between">
      <h-button type="default" :disabled="true">default</h-button>
      <h-button type="warning" :disabled="true">warning</h-button>
      <h-button type="primary" :disabled="true">primary</h-button>
      <h-button type="text" :disabled="true">text</h-button>
    </div>
    <h2>按钮样式-size=big</h2>
    <div style="display: flex;width: 500px;justify-content: space-between">
      <h-button type="default" size="big">default</h-button>
      <h-button type="warning" size="big">warning</h-button>
      <h-button type="primary" size="big">primary</h-button>
      <h-button type="text" size="big">text</h-button>
    </div>
    <h2>按钮样式-loading动画</h2>
    <div style="display: flex;width: 500px;justify-content: space-between">
      <h-button type="default" :loading="true">default</h-button>
      <h-button type="warning" :loading="true">warning</h-button>
      <h-button type="primary" :loading="true">primary</h-button>
      <h-button type="text" :loading="true">text</h-button>
    </div>
    <h2>按钮样式-劫持图标(iconpark)动态loading动画</h2>
    <div style="display: flex;width: 500px;justify-content: space-between">
      <h-button type="default" :loading="button.default" @click="button.default=true">
        <template #icon>
          <search theme="outline"/>
        </template>
        default
      </h-button>
      <h-button type="warning" :loading="button.warning" @click="button.warning=true">
        <template #icon>
          <code-download theme="outline"/>
        </template>
        warning
      </h-button>
      <h-button type="primary" :loading="button.primary" @click="button.primary=true">
        <template #icon>
          <upload-one theme="outline"/>
        </template>
        primary
      </h-button>
      <h-button type="text" :loading="button.text" @click="button.text=true">
        <template #icon>
          <setting-two theme="outline"/>
        </template>
        text
      </h-button>
    </div>
    <h2>按钮样式-自定义(img)动态loading动画</h2>
    <div style="display: flex;width: 500px;justify-content: space-between">
      <h-button type="default" :loading="button.img1" @click="button.img1=true">
        <template #icon>
          <img src="@/assets/svg/loading.svg" style="width: 14px;" alt="">
        </template>
        default
      </h-button>
      <h-button type="warning" :loading="button.img2" @click="button.img2=true">
        <template #icon>
          <img src="@/assets/svg/warning.svg" style="width: 14px;" alt="">
        </template>
        warning
      </h-button>
      <h-button type="primary" :loading="button.img3" @click="button.img3=true">
        <template #icon>
          <img src="@/assets/svg/success.svg" style="width: 14px;" alt="">
        </template>
        primary
      </h-button>
      <h-button type="text" :loading="button.img4" @click="button.img4=true">
        <template #icon>
          <img src="@/assets/svg/notArrived.svg" style="width: 14px;" alt="">
        </template>
        text
      </h-button>
    </div>
    <h2>按钮组样式 h-button-group</h2>
    <h3>按钮组样式-散列（默认）</h3>
    <h-button-group>
      <h-button type="default">default</h-button>
      <h-button type="warning">warning</h-button>
      <h-button type="primary">primary</h-button>
    </h-button-group>
    <h3>按钮组样式-成组（merge）</h3>
    <h-button-group merge>
      <h-button type="default">default</h-button>
      <h-button type="warning">warning</h-button>
      <h-button type="primary">primary</h-button>
    </h-button-group>
    <h3>按钮组样式-散列-big（默认）</h3>
    <h-button-group>
      <h-button type="default" size="big">default</h-button>
      <h-button type="warning" size="big">warning</h-button>
      <h-button type="primary" size="big">primary</h-button>
    </h-button-group>
    <h3>按钮组样式-成组-big（merge）</h3>
    <h-button-group merge>
      <h-button type="default" size="big">default</h-button>
      <h-button type="warning" size="big">中文</h-button>
      <h-button type="primary" size="big">primary</h-button>
    </h-button-group>
    <h3>按钮组样式-散列-对齐方式align=left（默认）</h3>
    <h-button-group align="left">
      <h-button type="default">default</h-button>
      <h-button type="warning">warning</h-button>
      <h-button type="primary">primary</h-button>
    </h-button-group>
    <h3>按钮组样式-散列-对齐方式align=center</h3>
    <h-button-group align="center">
      <h-button type="default">default</h-button>
      <h-button type="warning">warning</h-button>
      <h-button type="primary">primary</h-button>
    </h-button-group>
    <h3>按钮组样式-散列-对齐方式align=right</h3>
    <h-button-group align="right">
      <h-button type="default">default</h-button>
      <h-button type="warning">warning</h-button>
      <h-button type="primary">primary</h-button>
    </h-button-group>
    <h3>按钮组样式-成组-对齐方式align=left（默认）</h3>
    <h-button-group align="left" merge>
      <h-button type="default">default</h-button>
      <h-button type="warning">warning</h-button>
      <h-button type="primary">primary</h-button>
    </h-button-group>
    <h3>按钮组样式-成组-对齐方式align=center</h3>
    <h-button-group align="center" merge>
      <h-button type="default">default</h-button>
      <h-button type="warning">warning</h-button>
      <h-button type="primary">primary</h-button>
    </h-button-group>
    <h3>按钮组样式-成组-对齐方式align=right</h3>
    <h-button-group align="right" merge>
      <h-button type="default">default</h-button>
      <h-button type="warning">warning</h-button>
      <h-button type="primary">primary</h-button>
    </h-button-group>
    <!--    <h2>下拉按钮列表 h-select-group（正在开发）</h2>-->
    <!--    <h-select-group>-->
    <!--      <h-button type="default">下拉按钮</h-button>-->
    <!--      <template #list>-->
    <!--        <h-button>default</h-button>-->
    <!--        <h-button>warning</h-button>-->
    <!--        <h-button>primary</h-button>-->
    <!--      </template>-->
    <!--    </h-select-group>-->
    <h2>文件上传-手动上传</h2>
    <h-button @click="upload=true">文件上传</h-button>
    <h-dialog :show="upload" title="文件上传" footer @close="upload=false">
      <h-upload @file-change="chooseFile" :max="30" :max-lenght="10" @error="errorFile" :file-list="fileList">
        <template #tips>
          <div>*请注意文件上传的格式（BMP、JPG、JPEG、PNG、GIF、PDF），文件名中不允许出现逗号，最多允许上传10个文件且单个文件不大于30M*</div>
        </template>
      </h-upload>
      <template #footer>
        <h-button-group align="right">
          <h-button type="primary" @click="uploadFile" :loading="uploadLoading">
            <template #icon>
              <upload theme="outline"/>
            </template>
            确认上传
          </h-button>
        </h-button-group>
      </template>
    </h-dialog>
    <h2>文件上传-自动上传</h2>
    <h-button @click="upload2=true">文件上传</h-button>
    <h-dialog :show="upload2" title="文件上传" @close="upload2=false">
      <h-upload :max="30" :max-lenght="10" @error="errorFile" :auto-upload="true" @upload="autoUpload" h-accept="doc,docx">
        <template #tips>
          <div>*请注意文件上传的格式（BMP、JPG、JPEG、PNG、GIF、PDF），文件名中不允许出现逗号，最多允许上传10个文件且单个文件不大于30M*</div>
        </template>
      </h-upload>
    </h-dialog>
    <h2>列表页通用h-list-page</h2>
    <h3>搜索条件h-card</h3>
    <h-list-page>
      <h-card title="搜索条件h-card" width="100%" footer is-search>
        <h-area title-width="90px" :all-span="7">
          <h-row>
            <h-col>
              <h-search title="测试h-search">
                <el-input v-model="test" clearable></el-input>
              </h-search>
            </h-col>
            <h-col>
              <h-search title="测试">
                <el-input v-model="test" clearable></el-input>
              </h-search>
            </h-col>
            <h-col>
              <h-search title="测试">
                <el-input v-model="test" clearable></el-input>
              </h-search>
            </h-col>
            <h-col right :span="3">
              <h-button type="primary" :loading="loading" @click="loading=true">
                <template #icon>
                  <search/>
                </template>
                查询
              </h-button>
            </h-col>
          </h-row>
          <h-row>
            <h-col>
              <h-search title="测试带*号" required>
                <el-input v-model="test" clearable></el-input>
              </h-search>
            </h-col>
            <h-col>
              <h-search title="测试">
                <el-input v-model="test" clearable></el-input>
              </h-search>
            </h-col>
            <h-col>
              <h-search title="测试">
                <el-input v-model="test" clearable></el-input>
              </h-search>
            </h-col>
          </h-row>
          <h-row>
            <h-col>
              <h-search title="弹出h-dialog">
                <h-button type="primary" @click="planeDetails.show=true">弹出层</h-button>
              </h-search>
            </h-col>
            <h-col>
              <h-search title="弹出h-detail">
                <h-button type="primary" @click="planeDetails1.show=!planeDetails1.show">弹出可定位弹出层</h-button>
              </h-search>
            </h-col>
            <h-col>
              <h-search title="弹出h-dialog">
                <h-button type="primary" @click="planeDetails3.show=true">弹出操作层</h-button>
              </h-search>
            </h-col>
          </h-row>
        </h-area>
      </h-card>
      <h-detail width="600px" top="253px" left="453px">
        <el-table v-show="planeDetails1.show" :data="supplierList" border size="small" max-height="252">
          <el-table-column prop="supplyCode" label="供应商代码" width="120"></el-table-column>
          <el-table-column prop="supplyName" label="供应商名称"></el-table-column>
        </el-table>
      </h-detail>
      <h-dialog title="这里是示例标题" :show="planeDetails.show" width="1120px" @close="planeDetails.show=false">
        <div style="margin-bottom: 20px">
          <span>专用号：0060112817</span>
          <span style="margin-left: 10px">物料名称：测试物料名称</span>
          <span style="margin-left: 10px">物料总数量：3300</span>
        </div>
        <div style="margin-bottom: 20px">
          <span>供应商代码：V12970</span>
          <span style="margin-left: 10px">供应商名称：不知道啥名</span>
        </div>
        <div>
          <el-table empty-text="空数据" ref="tableDatatable"
                    border :data="planeDetails.data" size="small" height="400" style="width: 100%">
            <el-table-column type="index" width="40" label="序号"></el-table-column>
            <el-table-column prop="targetFactory" label="供货工厂" width="80"></el-table-column>
            <el-table-column prop="factory" label="配额工厂" width="180"></el-table-column>
            <el-table-column prop="exceptQt" label="送货数量" width="80"></el-table-column>
            <el-table-column prop="unit" label="单位" width="80"></el-table-column>
            <el-table-column prop="warehouseAreaName" label="库区名称"></el-table-column>
            <el-table-column prop="warehouseLocation" label="库位"></el-table-column>
            <el-table-column prop="createdTime" label="计划生成时间" width="170" :formatter="timeGC"></el-table-column>
          </el-table>
        </div>
      </h-dialog>
      <h-dialog title="操作示例" :show="planeDetails3.show" width="752px" @close="planeDetails3.show=false" footer>
        <h-row>
          <h-col :span="12">
            <h-top-search title="测试1" no-value>V12970</h-top-search>
          </h-col>
          <h-col :span="12">
            <h-top-search title="测试1测试1测试1测试1测试1测试1测试1测试1测试1测试1测试1测试1" no-value>no-value属性用于展示非操作输入框</h-top-search>
          </h-col>
        </h-row>
        <h-row>
          <h-col :span="12">
            <h-top-search title="测试1" no-value>no-value属性用于展示非操作输入框</h-top-search>
          </h-col>
          <h-col :span="12">
            <h-top-search title="测试1" no-value>no-value属性用于展示非操作输入框</h-top-search>
          </h-col>
        </h-row>
        <h-row>
          <h-col :span="12">
            <h-top-search title="测试1" no-value>no-value属性用于展示非操作输入框</h-top-search>
          </h-col>
          <h-col :span="12">
            <h-top-search title="测试1" required>
              <el-input v-model="test" clearable></el-input>
            </h-top-search>
          </h-col>
        </h-row>
        <template #footer>
          <h-button-group align="right">
            <h-button type="primary">提交</h-button>
            <h-button type="default">返回</h-button>
          </h-button-group>
        </template>
      </h-dialog>
    </h-list-page>
    <h3>报表页面解决方案 tr-24份</h3>
    <h-inspection-page title="这里是标题">
      <report-form-header title="这里是标题" title-height="80px">
        <template #title>
          <div>
            <div>asdasdasdasdas</div>
            <div>asdasdasdasdas</div>
          </div>
        </template>
        <template #body>
          <h-tr>1|以此类推,随意组合</h-tr>
          <tr>
            <report-td title="专" colspan="1:23">测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试</report-td>
          </tr>
          <tr>
            <report-td title="专用号" colspan="2:22">测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试</report-td>
          </tr>
          <tr>
            <report-td title="专用号" colspan="3:21">测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试</report-td>
          </tr>
          <tr>
            <report-td title="专用号" colspan="4:20">测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试</report-td>
          </tr>
          <h-tr>2|3:9随意组合</h-tr>
          <tr>
            <report-td title="专用号" colspan="3:9">测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试</report-td>
            <report-td title="专用号" colspan="3:9">测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试</report-td>
          </tr>
          <h-tr>3|2:6随意组合</h-tr>
          <tr>
            <report-td title="专用号" colspan="2:6">测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试</report-td>
            <report-td title="专用号" colspan="2:6">测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试</report-td>
            <report-td title="专用号" colspan="2:6">测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试</report-td>
          </tr>
          <h-tr>4|2:6随意组合</h-tr>
          <tr>
            <report-td title="专" colspan="1:5">测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试</report-td>
            <report-td title="专" colspan="1:5">测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试</report-td>
            <report-td title="专" colspan="1:5">测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试</report-td>
            <report-td title="专" colspan="1:5">测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试</report-td>
          </tr>
          <tr>
            <report-td title="专用号" colspan="2:4">测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试</report-td>
            <report-td title="专用号" colspan="2:4">测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试</report-td>
            <report-td title="专用号" colspan="2:4">测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试</report-td>
            <report-td title="专用号" colspan="2:4">测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试</report-td>
          </tr>
          <h-tr>搜索框</h-tr>
          <tr>
            <report-td title="专用号" colspan="2:4">
              <el-input v-model="test" clearable></el-input>
            </report-td>
            <report-td title="专用号" colspan="2:4">
              <el-select placeholder="请选择" clearable>
                <el-option v-for="i in 4" :key="i" :label="i" :value="i">
                </el-option>
              </el-select>
            </report-td>
            <report-td title="专用号" colspan="2:4">
              <el-date-picker type="date" v-model="a" clearable></el-date-picker>
            </report-td>
            <report-td title="专用号" colspan="2:4">测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试</report-td>
          </tr>
          <tr>
            <report-td title="专用号" colspan="3:9">
              <el-input v-model="test" clearable></el-input>
            </report-td>
            <report-td title="专用号" colspan="3:9">
              <el-select placeholder="请选择" clearable>
                <el-option v-for="i in 4" :key="i" :label="i" :value="i">
                </el-option>
              </el-select>
            </report-td>
          </tr>
          <tr>
            <report-td title="专用号" colspan="3:9" :last-line="false">
              <el-input v-model="test" clearable></el-input>
            </report-td>
            <report-td title="专用号" colspan="3:9" :last-line="false">
              <el-select placeholder="请选择" clearable>
                <el-option v-for="i in 4" :key="i" :label="i" :value="i">
                </el-option>
              </el-select>
            </report-td>
          </tr>
          <h-tr>禁用溢出隐藏</h-tr>
          <tr>
            <report-td title="title溢出隐藏value禁用溢出隐藏" colspan="2:4" :on-line="[true,false]">测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试</report-td>
            <report-td title="title禁用溢出隐藏value禁用溢出隐藏" colspan="2:4" :on-line="[false,false]">测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试</report-td>
            <report-td title="title禁用溢出隐藏value溢出隐藏" colspan="2:4" :on-line="[false,true]">测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试</report-td>
            <report-td title="title溢出隐藏value溢出隐藏默认可不写" colspan="2:4" :on-line="[true,true]">测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试</report-td>
          </tr>
        </template>
      </report-form-header>
    </h-inspection-page>
    <report-form-header title="这里是标题" title-height="80px">
      <template #title>
        <div>
          <div>asdasdasdasdas</div>
          <div>asdasdasdasdas</div>
        </div>
      </template>
      <template #body>
        <h-tr>1|以此类推,随意组合</h-tr>
        <tr>
          <report-td title="专" colspan="1:23">测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试</report-td>
        </tr>
        <tr>
          <report-td title="专用号" colspan="2:22">测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试</report-td>
        </tr>
        <tr>
          <report-td title="专用号" colspan="3:21">测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试</report-td>
        </tr>
        <tr>
          <report-td title="专用号" colspan="4:20">测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试</report-td>
        </tr>
        <h-tr>2|3:9随意组合</h-tr>
        <tr>
          <report-td title="专用号" colspan="3:9">测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试</report-td>
          <report-td title="专用号" colspan="3:9">测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试</report-td>
        </tr>
        <h-tr>3|2:6随意组合</h-tr>
        <tr>
          <report-td title="专用号" colspan="2:6">测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试</report-td>
          <report-td title="专用号" colspan="2:6">测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试</report-td>
          <report-td title="专用号" colspan="2:6">测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试</report-td>
        </tr>
        <h-tr>4|2:6随意组合</h-tr>
        <tr>
          <report-td title="专" colspan="1:5">测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试</report-td>
          <report-td title="专" colspan="1:5">测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试</report-td>
          <report-td title="专" colspan="1:5">测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试</report-td>
          <report-td title="专" colspan="1:5">测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试</report-td>
        </tr>
        <tr>
          <report-td title="专用号" colspan="2:4">测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试</report-td>
          <report-td title="专用号" colspan="2:4">测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试</report-td>
          <report-td title="专用号" colspan="2:4">测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试</report-td>
          <report-td title="专用号" colspan="2:4">测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试</report-td>
        </tr>
        <h-tr>搜索框</h-tr>
        <tr>
          <report-td title="专用号" colspan="2:4">
            <el-input v-model="test" clearable></el-input>
          </report-td>
          <report-td title="专用号" colspan="2:4">
            <el-select placeholder="请选择" clearable>
              <el-option v-for="i in 4" :key="i" :label="i" :value="i">
              </el-option>
            </el-select>
          </report-td>
          <report-td title="专用号" colspan="2:4">
            <el-date-picker type="date" v-model="a" clearable></el-date-picker>
          </report-td>
          <report-td title="专用号" colspan="2:4">测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试</report-td>
        </tr>
        <tr>
          <report-td title="专用号" colspan="3:9">
            <el-input v-model="test" clearable></el-input>
          </report-td>
          <report-td title="专用号" colspan="3:9">
            <el-select placeholder="请选择" clearable>
              <el-option v-for="i in 4" :key="i" :label="i" :value="i">
              </el-option>
            </el-select>
          </report-td>
        </tr>
        <tr>
          <report-td title="专用号" colspan="3:9" :last-line="false">
            <el-input v-model="test" clearable></el-input>
          </report-td>
          <report-td title="专用号" colspan="3:9" :last-line="false">
            <el-select placeholder="请选择" clearable>
              <el-option v-for="i in 4" :key="i" :label="i" :value="i">
              </el-option>
            </el-select>
          </report-td>
        </tr>
        <h-tr>禁用溢出隐藏</h-tr>
        <tr>
          <report-td title="title溢出隐藏value禁用溢出隐藏" colspan="2:4" :on-line="[true,false]">测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试</report-td>
          <report-td title="title禁用溢出隐藏value禁用溢出隐藏" colspan="2:4" :on-line="[false,false]">测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试</report-td>
          <report-td title="title禁用溢出隐藏value溢出隐藏" colspan="2:4" :on-line="[false,true]">测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试</report-td>
          <report-td title="title溢出隐藏value溢出隐藏默认可不写" colspan="2:4" :on-line="[true,true]">测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试</report-td>
        </tr>
      </template>
    </report-form-header>
    <el-table
        ref="multipleTableRef"
        :data="planeDetails.data"
        style="width: 100%"
    >
      <el-table-column type="selection" width="55"/>
      <el-table-column label="Date" width="120">
        <template #default="scope">{{ scope.row.date }}</template>
      </el-table-column>
      <el-table-column property="name" label="Name" width="120"/>
      <el-table-column property="address" label="Address" show-overflow-tooltip/>
    </el-table>
    <div style="margin-top: 20px">
      <el-button @click="toggleSelection([tableData[1], tableData[2]])"
      >Toggle selection status of second and third rows
      </el-button
      >
      <el-button @click="toggleSelection()">Clear selection</el-button>
    </div>
    <h-button type="primary" @click="step=!step">弹出框</h-button>
    <h-dialog :show="step" title="日志" footer width="1000px" @close="step=false">
      <h-step :list="list">
        <template #default="{scope,index}">
          <template v-if="index===1">
            <el-select v-model="value" placeholder="请选择" clearable :popper-append-to-body="false">
              <el-option :key="1" label="通过" value="通过"></el-option>
              <el-option :key="2" label="驳回" value="驳回"></el-option>
            </el-select>
          </template>
        </template>
        <template #opinion="{scope,index}">
          <template v-if="index===1||index===2">
            <el-input type="textarea"></el-input>
          </template>
          <template v-else>
            {{ scope.description }}
          </template>
        </template>
      </h-step>
      <template #footer>
        <h-button-group align="right">
          <h-button type="primary">提交</h-button>
          <h-button type="default">返回</h-button>
        </h-button-group>
      </template>
    </h-dialog>
    <h-button type="primary" @click="up=!up">xlsx上传</h-button>
    <h-upload-template :loading="loadingDown" title="模版导入" :show="up" @close="up=false" status="success" :dataList="['上传成功']" @download="download"></h-upload-template>
  </div>

</template>

<script>
import ReportFormHeader from "@/views/Templates/reportForm-header";

export default {
  name: "h-help",
  components: {ReportFormHeader},
  data() {
    return {
      postData:{},
      loadingDown: false,
      up: false,
      button: {},
      fileList: [],
      upload: false,
      upload2: false,
      uploadLoading: false,
      file: {},
      detail1: false,
      detail2: false,
      planeDetails: {
        data: [],
        show: false
      },
      step: false,
      value: "",
      test: "",
      planeDetails1: {
        show: false
      },
      supplierList: [],
      planeDetails3: {
        show: false
      },
      list: [{
        title: '发起人张三',
        userCode: '12345678',
        tag: "发起",
        createTime: '2023-04-21 13:00:00',
        status: 'success',
      },
        {
          title: '一级审批人李四',
          userCode: '12345679',
          tag: "审核通过",
          createTime: '2023-04-21 13:00:00',
          description: '申请办公用品',
          status: 'success'
        },
        {
          title: '二级审批人王五',
          userCode: '12345670',
          tag: "审核驳回",
          createTime: '2023-04-21 13:00:00',
          description: '申请办公用品',
          status: 'error'
        },
        {
          title: '三级审批人王二麻子',
          userCode: '02345678',
          createTime: '',
          description: '申请办公用品',
          status: 'default'
        },
        {
          title: '最终节点',
          userCode: '02345679',
          tag: "软件开发",
          createTime: '',
          description: '申请办公用品',
          status: 'wait'
        }]
    }
  },
  created() {
    for (let i = 0; i < 10; i++) {
      this.planeDetails.data.push({
        targetFactory: "9090",
        factory: "9090，9091",
        exceptQt: "9099",
        unit: "EA",
        warehouseAreaName: "青岛某",
        warehouseLocation: "青岛某",
        createdTime: "2022-12-27 ",
      })
    }
    for (let i = 0; i < 10; i++) {
      this.supplierList.push({
        supplyCode: "V12970",
        supplyName: "未知"
      })
    }
    setTimeout(() => {
      this.list[4].status = "success"
    }, 1000)
  },
  methods: {
    download() {
      this.loadingDown = true
      setTimeout(() => {
        this.loadingDown = false
      }, 300)
    },
    happenEndTimeChange(){},
    pageTimeChange(){},
    pageTime2Change(){
      console.log('pageTime',this.postData.pageTime)
    },
    pageTime3Change(){
      console.log('pageTime',this.postData.pageTime)
    },
    pageTime4Change(){
      console.log('pageTime',this.postData.pageTime)
    },
    chooseFile(file, fileList) {
      this.fileList = fileList
    },
    errorFile(str) {
      this.info(str)
    },
    autoUpload(file) {
      this.file = file
      let formData = new FormData()
      // this.file.progress = 50
      formData.append("files", file.file)
      return this.$http({
        method: 'post',
        url: '/base/fileUpload/uploadToOssSaveUrl',
        headers: {'Content-Type': 'multipart/form-data'},
        data: formData,
        onUploadProgress: (progressEvent) => {
          console.log('进度', progressEvent, (progressEvent.loaded / progressEvent.total).toFixed(1))
          this.file.progress = (progressEvent.loaded / progressEvent.total).toFixed(1) * 100
        }
      }).then((res) => {
        if (res.data.code === "0") {
          // this.file.progress = 100
          this.file.status = "success"
        } else {
          return Promise.reject()
        }
      }).catch((err) => {
        // this.file.progress = 100
        this.file.status = "fail"
        this.error("上传失败")
      });
    },
    uploadFile() {
      let uploadFileList = this.fileList.filter(v => v.status === "default")
      if (uploadFileList.length === 0) {
        this.info("请选择文件")
        return false
      }
      let formData = new FormData()
      uploadFileList.map(v => {
        formData.append('files', v.file)
        v.progress = 50
      })
      this.uploadLoading = true
      return this.$http({
        method: 'post',
        url: '/base/fileUpload/uploadToOssSaveUrl',
        headers: {'Content-Type': 'multipart/form-data'},
        data: formData,
        onUploadProgress: function (progressEvent) {
          console.log('进度', progressEvent)
        }
      }).then((res) => {
        this.uploadLoading = false
        if (res.data.code === "0") {
          uploadFileList.map(v => {
            v.progress = 100
            v.status = "success"
          })
        } else {
          return Promise.reject()
        }
      }).catch((err) => {
        this.uploadLoading = false
        uploadFileList.map(v => {
          v.progress = 100
          v.status = "fail"
        })
      });
    }
  }
}
</script>

<style lang="scss">
.haier-help {
  width: 1150px;
  margin: 0 auto;
  padding-bottom: 400px;
}
</style>
